import { render, staticRenderFns } from "./StavesZones.vue?vue&type=template&id=42e6434f&scoped=true&"
import script from "./StavesZones.vue?vue&type=script&lang=ts&"
export * from "./StavesZones.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./StavesZones.vue?vue&type=style&index=0&id=42e6434f&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "42e6434f",
  null
  ,true
)

export default component.exports